export type UseProjectTemplateProps = { onShareProject: (foramtTemplate: FormatTemplateType) => void | Promise<void> };

export type FormatTemplateType = {
  attrIndexer?: string;
  id: string;
  label: string;
  loading: boolean;
  relationId: string;
  uuid: string;
  value: string;
};

export enum Contents {
  Templates,
  Projects,
  Functions,
}

export interface VideoModalState {
  isOpen: boolean;
  videoUrl: string;
  videoName: string;
}
